import React from 'react';
import NumberFlow from '@number-flow/react'

export function BucketListItem({label = 'Label', emoji = '🪣', valueLeft = 0, percentage = 100, colour = 'green'}){

    const formattedValueLeft = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(valueLeft);

    let barColourClass;
    switch (colour) {
        case 'amber':
            barColourClass = 'bar-amber';
            break;
        case 'red':
            barColourClass = 'bar-red';
            break;
        case 'green':
        default:
            barColourClass = 'bar-green';
            break;
    }

    return (
        <div className='flex justify-center items-center gap-4 relative w-full bg-slate-50 dark:bg-slate-900 rounded-xl ring-1 ring-black/10 dark:ring-white/10 ring-inset px-4 py-3'>
            <span className='text-3xl'>{emoji}</span>
            <div className='flex flex-col w-full'>
                <span className='text-base font-medium text-slate-950 dark:text-white'>{label}</span>
                <span className='text-xs font-bold text-slate-500 dark:text-slate-400'><NumberFlow value={valueLeft} format={{ style: 'currency', currency: 'GBP' }} /> left</span>
                
            </div>
            <div className={`block relative w-full h-4 ring-1 ring-black/10 ring-inset rounded-full overflow-hidden transition-all ${barColourClass}`}>
                <div className={`percentage-bar block absolute left-0 top-0 h-full rounded-full transition-all duration-150`} style={{ width: `${percentage}%` }}></div>
            </div>
        </div>
    );
}

export function BucketList({children}){
    return (
        <div className='flex flex-col relative gap-2'>
            {children}
        </div>
    );
}

export function BucketCard({valueTotal = 0, valueLeft = 0, percentage = 100, colour = 'green'}){
    const formattedValueLeft = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(valueLeft);
    const formattedValueTotal = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(valueTotal);
    let barColourClass;
    switch (colour) {
        case 'amber':
            barColourClass = 'bar-amber';
            break;
        case 'red':
            barColourClass = 'bar-red';
            break;
        case 'green':
        default:
            barColourClass = 'bar-green';
            break;
    }
    return (
        <div className='flex flex-col gap-4'>
            <div className={`block relative w-full h-auto rounded-xl ring-1 ring-black/10 dark:ring-white/10 ring-inset  overflow-hidden transition-all ${barColourClass}`}>
                <div className={`percentage-bar block absolute left-0 top-0 h-full rounded-xl transition-all duration-150`} style={{ width: `${percentage}%` }}></div>
                <div className='flex justify-center items-center gap-4 relative w-full px-4 py-3'>
                    <span className='text-xl w-full font-semibold dark:text-white'><NumberFlow value={valueLeft} format={{ style: 'currency', currency: 'GBP' }} /></span>
                    <span className='text-xl font-semibold opacity-60 dark:text-white'>/</span>
                    <span className='text-xl w-full font-semibold text-right opacity-60 dark:text-white'>{formattedValueTotal}</span>
                </div>
            </div>
        </div>
    );
}